import { useCallback, useEffect, useMemo, useState } from "react";
import EndpointView from "./Components/EndpointView";
import FolderView from "./Components/FolderView";
import TreeSidebar from "./Components/TreeSidebar";
import { findNode, indexTree, readHash } from "./Components/PostmanVIewHelper";
import { postmanDataset } from "variables/postmanDataset";

export default function PostmanDocsViewer({ source = postmanDataset }) {
  const tree = useMemo(() => indexTree(source.item || []), [source]);
  const [selectedId, setSelectedId] = useState(() =>
    typeof window === "undefined" ? "" : readHash()
  );
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    const onHash = () => setSelectedId(readHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const select = useCallback((id) => {
    window.location.hash = id ? `/${id}` : "";
    setSelectedId(id);
    setNavOpen(false);
    window.scrollTo({ top: 0 });
  }, []);

  const node = selectedId ? findNode(tree, selectedId) : null;
  const title = source.name || "API documentation";

  return (
    <div className="ad-root">
      <header className="ad-topbar">
        <button
          type="button"
          className="ad-menu"
          aria-label="Toggle navigation"
          aria-expanded={navOpen}
          onClick={() => setNavOpen((v) => !v)}
        >
          <svg viewBox="0 0 20 20" width="20" height="20">
            <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </button>
        <span>{title}</span>
      </header>

      <TreeSidebar title={title} tree={tree} selectedId={selectedId} onSelect={select} open={navOpen} />

      <main className="ad-main">
        {!node ? (
          <FolderView isRoot title={title} tree={tree} onSelect={select} />
        ) : node.kind === "folder" ? (
          <FolderView node={node} tree={tree} onSelect={select} />
        ) : (
          <EndpointView node={node} tree={tree} onSelect={select} />
        )}
      </main>
    </div>
  );
}